const mainComponentGame = document.querySelector('#wl-game-integration-plugin');
if (mainComponentGame) {
    hookGamePlayPage();
}

function invertPriceCurrency(priceString) {
    if(!priceString) {
        return priceString;
    }
    const match = priceString.trim().match(/^([\d,]+)(\D+)$/);
    
    if (match) {
        return `${match[2].trim()}${match[1].trim()}`;
    }
    
    return priceString;
}

function hookGamePlayPage() {
    const gameMainWindow = document.querySelector('[data-game-play-page]');
    if (!gameMainWindow) {
        return;
    }

    var path = window.location.pathname;
    let urlArray = path.split('/');
    let tournamentId = urlArray[urlArray.length - 2];
    let parameters = {
        headers: {
            'content-type': 'application/json',
            Authorization: settings.token,
            username: settings.username,
            license: settings.pp_wl_game_client_id,
        },
        method: 'GET',
        //body: JSON.stringify({ tournament_id: tournamentId }),
    };
    fetch(
        settings.rest_api_url + 'getRunningTournament/' + tournamentId,
        parameters
    )
        .then(async (response) => {
            if (response.ok) {
                const resp = await response.json();
                resp.data.displayPrizes = invertPriceCurrency(
                    resp.data.displayPrizes
                );
                resp.data.totalPrizePoolNew = invertPriceCurrency(resp.data.totalPrizePoolNew);
                resp.data.prizePool = invertPriceCurrency(resp.data.prizePool);
                for(const scoreBoard of resp.data.liveScoreboardHighlight) {
                    scoreBoard.displayPrizes = invertPriceCurrency(scoreBoard.displayPrizes);
                }
                for(const scoreBoard of resp.data.liveScoreboard) {
                    scoreBoard.displayPrizes = invertPriceCurrency(scoreBoard.displayPrizes);
                }
                return resp;
            } else if (response.status == 401 || response.status == 403) {
                return response.json();
            } else {
                throw new Error(
                    'Could not reach the API: ' + response.statusText
                );
            }
        })
        .then((result) => {
            if (result.success) {
                result.data.liveScoreboard =
                    result.data.liveScoreboardHighlight.concat(
                        result.data.liveScoreboard
                    );
                handlebarTemplateGamePlay(
                    '#game-play-page',
                    '[data-game-play-page]',
                    result.data
                );
                handlebarTemplateGamePlay(
                    '#play-bottom-counter',
                    '#mobile-footer-counter',
                    result.data
                );
                tournamentTimer();
                hookGame();
            } else {
                if (
                    result.message &&
                    result.message == 'Invalid License Received'
                ) {
                    handlebarTemplateJS(
                        '#invalid-license',
                        '[data-game-play-page]',
                        {}
                    );
                }
                if (result.message && result.message == 'Country is blocked') {
                    handlebarTemplateJS(
                        '#blocked-country',
                        '[data-game-play-page]',
                        {}
                    );
                }
            }
        })
        .catch((error) => {
            console.error(error);
        });
}

function hookGame() {
    const gameWindow = document.querySelector('[data-tournament]');
    const overlayMessageMainDiv = document.querySelector(
        '[data-game-play-overlay]'
    );
    if (!gameWindow) return;
    const tournament_id = gameWindow.dataset.tournament;
    const iframeURL = new URL(
        gameWindow.querySelector('iframe').getAttribute('src')
    );
    const windowOrigin = iframeURL.origin;
    let toBeKilled = false;
    let gameEnded = false;
    let spinCountInCurrentSession = null;
    let tournamentType = '';

    let playerSpins = false;
    let lastResponseSpinNr = 0;
    let playerScore = false;
    let betSize = false;
    let spinsLimit = false;
    let gameEnds = false;
    let token = false;
    let apiURL = false;
    let language = document.querySelector('#wl-game-integration-plugin').dataset
        .language;
    let resultVerified = false;
    let checkGameEndInterval = false;

    let prizes = false;
    if ('prizePool' in window) {
        prizes = window.prizePool;
    }

    getSessionData()
        .then((r) => {
            playerSpins = parseInt(r.playerSpins);
            lastResponseSpinNr = playerSpins;
            spinsLimit = parseInt(r.spinsLimit);
            playerScore = r.playerScore;
            betSize = r.betSize;
            apiURL = r.apiURL;
            gameEnds = parseInt(r.gameEnds);
            token = r.token;
            tournamentType = r.tournamentType;

            missions = r.missions;
            comebackCounter = r.comebackCounter;

            if (playerSpins === spinsLimit) {
                toBeKilled = true;
            }

            updateSidebarScore();
            updateSpinsCount(spinsLimit - playerSpins);

            checkGameEndInterval = setInterval(() => {
                checkGameEnd();
            }, 1000);
        })
        .catch((er) => {
            console.error(er);
        });

    const sidebarUserScore = gameWindow.querySelectorAll('[data-user-score]');
    const gameOverlay = overlayMessageMainDiv.querySelector(
        '[data-game-overlay]'
    );
    const gameOverlayMessage = overlayMessageMainDiv.querySelector(
        '[data-game-overlay-message]'
    );
    const gameOverlayIncorrectBetSize = gameWindow.querySelector(
        '[data-game-overlay-bet]'
    );
    const gameOverlayIncorrectBetSizeClose = gameWindow.querySelector(
        '[data-game-overlay-bet-close]'
    );

    if (gameOverlayIncorrectBetSizeClose) {
        gameOverlayIncorrectBetSizeClose.addEventListener('click', () => {
            gameOverlayIncorrectBetSize.style.display = 'none';
        });
    }

    window.addEventListener('message', receiveMessage, false);

    function endThisGame() {
        if (!gameEnded) {
            verifyResult();
        }
    }

    function verifyResult() {
        gameEnded = true;
        if (!resultVerified) {
            resultVerified = true;
            gameOverlay.style.display = '';

            let data = {};
            data.tournament_id = tournament_id;

            let parameters = {
                headers: {
                    'content-type': 'application/json',
                    Authorization: settings.token,
                    username: settings.username,
                    license: settings.pp_wl_game_client_id,
                },
                method: 'POST',
                body: JSON.stringify(data),
            };
            fetch(settings.rest_api_url + 'verifyResult/', parameters)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        throw new Error(
                            'Could not reach the API: ' + response.statusText
                        );
                    }
                })
                .then((result) => {
                    if (result.success) {
                        result.redirectUrl =
                            settings.pp_wl_game_result_page +
                            '?tournamentId=' +
                            tournament_id;
                        gameOverlayMessage.innerHTML =
                            generateVerifyScoreResultMessage(result);
                    } else {
                        gameEnded = false;
                        resultVerified = false;
                        if (r.redirect) {
                            gameOverlayMessage.innerHTML =
                                '<p>Something went wrong, refreshing game...</p>';

                            setTimeout(() => {
                                window.location.href = r.redirect;
                            }, 4000);
                        } else {
                            gameOverlay.hide();
                        }
                    }
                })
                .catch((error) => {
                    gameEnded = false;
                    resultVerified = false;
                    setTimeout(() => {
                        verifyResult();
                    }, 3000);
                });
        }
    }

    function generateVerifyScoreResultMessage(r) {
        let ret =
            '<p class="text-white">' +
            translate(language, 'you_have_scored') +
            '</p>' +
            '<p class="scored">' +
            formatScore(r.data.score) +
            '</p>';
        ret += '<p class="text-white">' + translate(language, 'points') + '</p>';
        ret +=
            '<p class="text-white">' +
            translate(language, 'thank_you_for_playing') +
            '</p>' +
            '<p><a href="' +
            r.redirectUrl +
            '" class="wl-btn-primary">' +
            translate(language, 'see_the_results') +
            '</a></p>';

        return ret;
    }

    function triggerSpin() {
        updateSidebarScore();

        if (!toBeKilled) {
            playerSpins++;
            let spinsToShow = spinsLimit - playerSpins;
            if (playerSpins >= spinsLimit) {
                toBeKilled = true;
                spinsToShow = 0;
            }

            updateSpinsCount(spinsToShow);
        }
        if (spinCountInCurrentSession != null) {
            spinCountInCurrentSession++;
        }
    }

    function receiveMessage(event) {
        if (event.data === 'goHome') {
            window.location.href = window.location.origin;
        }

        if (!verifyOrigin(event)) {
            return;
        }

        if (event.data.name === 'spinStarted') {
            updateSidebarScore();
        }

        if (event.data.name === 'spinEnded') {
        }

        if (event.data.name === 'freeSpinStarted') {
        }

        if (event.data.name === 'freeSpinEnded') {
        }

        if (event.data.name === 'bonusGameStarted') {
        }

        if (event.data.name === 'bonusGameEnded') {
        }

        if (event.data.name === 'gameRoundStarted') {
            triggerSpin();
        }

        if (event.data.name === 'gameRoundEnded') {
            updateGame();

            if (toBeKilled) {
                endThisGame();
            }
        }

        if (event.data.name === 'notifyCloseContainer') {
        }

        if (event.data.name === 'balanceTooLow') {
            updateGame();

            if (playerSpins === spinsLimit) {
                toBeKilled = true;
                endThisGame();
            }
        }
    }

    function verifyOrigin(event) {
        return event.origin === windowOrigin;
    }

    function updateGame() {
        if (!apiURL) {
            return;
        }

        let data = {
            token: token,
        };
        let parameters = {
            headers: { 'content-type': 'application/json' },
            method: 'POST',
            body: JSON.stringify(data),
        };
        fetch(apiURL + '/player/results', parameters)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error(
                        'Could not reach the API: ' + response.statusText
                    );
                }
            })
            .then((result) => {
                const response = result;

                const spinsTaken = parseInt(response.spins_taken);

                if (spinsTaken <= lastResponseSpinNr) {
                    return; // ignore response from previous spin and duplicated one
                }
                lastResponseSpinNr = spinsTaken;

                playerScore = response.score;
                updateSidebarScore();

                if (spinsTaken > playerSpins) {
                    playerSpins = spinsTaken;
                    updateSpinsCount(spinsLimit - spinsTaken);
                }

                updatePlayerPosition(response.position);

                if (playerSpins > 0) {
                }

                if ('scoreboard' in response) {
                }

                if ('notifications' in response) {
                }
            })
            .catch((error) => {
                console.error('Error processing request!', error);
            });
    }

    function updateSpinsCount(spinsLeft) {
        gameWindow.querySelector('[data-spins-left]').textContent = spinsLeft;
        let spinsMadeElement = gameWindow.querySelector('[data-spins-made]');
        if (spinsMadeElement) {
            spinsMadeElement.textContent = spinsLimit - spinsLeft;
        }
        gameWindow.querySelector('[data-spins-left-level]').style.width =
            (spinsLeft / spinsLimit) * 100 + '%';
    }

    function updateScoreValue(score) {
        const scoreText = formatScore(score);
        sidebarUserScore.forEach((element) => {
            element.textContent = scoreText;
        });
    }

    function updatePlayerPosition(newPosition) {
        gameWindow
            .querySelectorAll('[data-user-position]')
            .forEach((element) => {
                element.textContent = newPosition + '.';
            });
    }

    function getScoreFormatOptions(score) {
        return isMultiplierWin() && score > 0
            ? {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
              }
            : {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
              };
    }

    function formatScore(score) {
        if (isNaN(score)) {
            return score;
        }

        return Number(score).toLocaleString('en', getScoreFormatOptions(score));
    }

    function getSessionData() {
        return new Promise((resolve, reject) => {
            const parameters = {
                headers: {
                    'content-type': 'application/json',
                    Authorization: settings.token,
                    username: settings.username,
                    license: settings.pp_wl_game_client_id,
                },
                method: 'GET',
                // body: JSON.stringify({
                //     "tournament": tournament_id,
                // })
            };

            fetch(
                settings.rest_api_url + 'getSessionData/' + tournament_id,
                parameters
            )
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    } else if (
                        response.status == 401 ||
                        response.status == 403
                    ) {
                        return response.json();
                    } else {
                        throw new Error(
                            'Could not reach the API: ' + response.statusText
                        );
                    }
                })
                .then((result) => {
                    if (result.success) {
                        resolve({
                            playerSpins: parseInt(result.data.playerSpins),
                            spinsLimit: parseInt(result.data.spinsLimit),
                            playerScore: result.data.playerScore,
                            betSize: result.data.betSize,
                            tournamentType: result.data.tournamentType,
                            apiURL: result.data.apiURL,
                            gameEnds: result.data.gameEnds,
                            token: result.data.token,
                            missions: result.data.missions,
                            comebackCounter: result.data.comebackCounter,
                        });
                    } else {
                        if (
                            result.message &&
                            result.message == 'Invalid License Received'
                        ) {
                            handlebarTemplateJS(
                                '#invalid-license',
                                '[data-page-tournament-results]',
                                {}
                            );
                        }
                        if (
                            result.message &&
                            result.message == 'Country is blocked'
                        ) {
                            handlebarTemplateJS(
                                '#blocked-country',
                                '[data-page-tournament-results]',
                                {}
                            );
                        }
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        });
    }

    function updateSidebarScore() {
        updateScoreValue(playerScore);
    }

    function checkGameEnd() {
        const now = Math.floor(Date.now() / 1000);
        if (now >= gameEnds) {
            clearInterval(checkGameEndInterval);
            toBeKilled = true;
        }
    }

    function hasPrizeForPlace(placeNr) {
        return typeof prizes[placeNr - 1] !== 'undefined';
    }

    function getPrizeForPlace(placeNr) {
        return hasPrizeForPlace(placeNr) ? prizes[placeNr - 1] : '';
    }

    function isMultiplierWin() {
        return tournamentType === 'multiplier_win';
    }
}
